import { useTranslation } from "@localization/useTranslation.ts";
import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { LegalEntityTypeViewModel } from "./LegalEntityType.types.ts";
import { TableCell, TableRow } from "@mui/material";
import { Box } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import useLegalEntityTypesHooks from "./LegalEntityTypes.hooks.ts";
import AddEditLegalEntityTypeDialog from "../addEditLegalEntityTypeDialog/AddEditLegalEntityTypeDialog.tsx";
import DotLegalTableWithControlsLocalized from "@common/components/dotLegalTableWithControlsLocalized/DotLegalTableWithControlsLocalized.tsx";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function LegalEntityTypes() {
    const { translateString } = useTranslation();
    const {
        legalEntityTypes,
        isLoading,
        breadCrumbs,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        legalEntityTypeForDeletion,
        setLegalEntityTypeForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        legalEntityTypeForUpdate,
        isDeleting,
    } = useLegalEntityTypesHooks();

    const headers = Array<ITableHeader<LegalEntityTypeViewModel>>();
    headers.push({ property: "name", text: translateString("name") });
    headers.push({ property: "isCustom", text: translateString("standardMasterData") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={() => onCreateClick()}>
                            {translateString("createLegalEntityType")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControlsLocalized
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={legalEntityTypes}
                    emptyText={translateString("noLegalEntityTypes")}
                    defaultOrderBy={"name"}
                    getUserSpecificPageLength={() => 100}
                    clickableRows={false}
                    hasOverflowMenu
                    hideRowsPerPage={false}
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <Box sx={{ height: "20px !important" }}>{!row.isCustom ? <CheckIcon sx={{ height: "20px !important" }} /> : ""}</Box>
                            </TableCell>
                            <TableCell align={"right"}>{getMenuItems(row).length > 0 && <DotLegalOverflowMenu items={getMenuItems(row)} />}</TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {legalEntityTypeForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setLegalEntityTypeForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={legalEntityTypeForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || legalEntityTypeForUpdate !== undefined) && (
                <AddEditLegalEntityTypeDialog onDialogClose={onDialogClose} legalEntityTypeToUpdate={legalEntityTypeForUpdate} onSaved={onSaved} />
            )}
        </Box>
    );
}

export default LegalEntityTypes;
